module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN203_300638107.8547a134.png";